export default "__VITE_ASSET__Dv8aSXS7__"